import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

interface DayTemplate {
  dayName: string;
  dayOfWeek: number;
  isExpanded: boolean;
  exercises: any[];
  isRestDay: boolean;
}

interface CopyDayDialogData {
  weeklyTemplate: DayTemplate[];
  currentDayIndex: number;
}

@Component({
  selector: 'app-copy-day-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './copy-day-dialog.component.html',
  styleUrl: './copy-day-dialog.component.css',
})
export class CopyDayDialogComponent {
  weeklyTemplate: DayTemplate[];
  currentDayIndex: number;
  availableDays: DayTemplate[];

  constructor(
    public dialogRef: MatDialogRef<CopyDayDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CopyDayDialogData
  ) {
    this.weeklyTemplate = data.weeklyTemplate;
    this.currentDayIndex = data.currentDayIndex;

    // Filter out the current day and rest days
    this.availableDays = this.weeklyTemplate.filter(
      (day, index) => index !== this.currentDayIndex && !day.isRestDay
    );
  }

  getExerciseCount(day: DayTemplate): number {
    return day.exercises.filter((exercise) => exercise.exercise.trim() !== '')
      .length;
  }

  hasWarmupExercises(day: DayTemplate): boolean {
    return day.exercises.some(
      (exercise) =>
        exercise.section === 'warmup' && exercise.exercise.trim() !== ''
    );
  }

  hasMainExercises(day: DayTemplate): boolean {
    return day.exercises.some(
      (exercise) =>
        exercise.section === 'main' && exercise.exercise.trim() !== ''
    );
  }

  hasCooldownExercises(day: DayTemplate): boolean {
    return day.exercises.some(
      (exercise) =>
        exercise.section === 'cooldown' && exercise.exercise.trim() !== ''
    );
  }

  copyDay(selectedDayIndex: number): void {
    // Find the actual index in the original array
    const actualIndex = this.weeklyTemplate.findIndex(
      (day) => day === this.availableDays[selectedDayIndex]
    );
    this.dialogRef.close(actualIndex);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
